'use client';

import { useEffect } from 'react';
import {
  readPartnerTripId,
  watchPartnerVisitIdentify,
  type PartnerVisitIdentifyPayload,
} from './partnerVisitLink';

type TagularBeam = (
  channel: 'beam',
  eventName: string,
  payload: PartnerVisitIdentifyPayload,
) => void;

type CohesionReady = (event: 'tagular:ready', callback: () => void) => void;

type TagularReadyState = { ready?: boolean };

/**
 * Sends the linking Identify once `tagular:ready` and `rv_ctx` both have
 * a known partner trip id. `externalIdType` is `partner_trip_id`.
 * A blank name does not send. A partner session id is not sent here.
 */
export function PartnerVisitIdentify({
  externalIdType,
}: {
  externalIdType?: string;
}): null {
  useEffect(() => {
    return watchPartnerVisitIdentify({
      externalIdType,
      beam(eventName, payload) {
        const tagular = window.tagular as TagularBeam | undefined;
        if (typeof tagular !== 'function') return false;
        try {
          tagular('beam', eventName, payload);
          return true;
        } catch {
          return false;
        }
      },
      readVisitId: () => readPartnerTripId(),
      getCohesion: () => window.cohesion as CohesionReady | undefined,
      isTagularReady: () =>
        (window as Window & { _Tagular?: TagularReadyState })._Tagular
          ?.ready === true,
      schedule(callback, delayMs) {
        const id = window.setInterval(callback, delayMs);
        return () => window.clearInterval(id);
      },
    });
  }, [externalIdType]);

  return null;
}
